import { ChangeDetectionStrategy, Component, OnInit, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'dl-qn-sbn-eservices',
  templateUrl: './qn-sbn-eservices.component.html',
  styleUrls: ['./qn-sbn-eservices.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class QnSbnEservicesComponent implements OnInit {
  public constructor() {}

  public ngOnInit(): void {}
}
